import axios from 'axios';

const authenticationService = {
    login(email,password){

        const payload = {
            email: email,
            password: password
        };

        let isAuthenticated;

        return axios.post(`/api/login`,payload)
        .then((res) => {
            if(res.status === 200){
                isAuthenticated = true;
            }
            else{
                isAuthenticated = false;
            }

            return isAuthenticated;
        })
        .catch((err) => {
            throw err;
        });

    },
    logout(){

        return axios.post('/api/logout')
        .then((res) => {  
            return false;
        })
        .catch((err) => {
            throw(err);
        });
        
    }
}

export default authenticationService;